import { StringParam, withDefault } from 'use-query-params';
import {
  CustomStringParam,
  FilterType,
  SchemaFilterType,
  SortDir,
} from '@ui/src';
import { ApplicationType, NewApplicationStatus } from '../../types';

export const newApplicationListColumns = [
  {
    name: 'id',
    label: 'Doc N.',
    hidden: false,
  },
  {
    name: 'createdAt',
    label: 'Date subm.',
    hidden: false,
    sortable: true,
  },
  {
    name: 'firstName',
    label: 'First Name',
    hidden: false,
    sortable: true,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    hidden: false,
    sortable: true,
  },
  {
    name: 'companyName',
    label: 'Company Name',
    hidden: false,
    sortable: true,
  },
  {
    name: 'reviewEmployeeId',
    label: 'Responsible',
    hidden: false,
    sortable: false,
  },
  {
    name: 'email',
    label: 'Email',
    hidden: false,
    sortable: true,
  },
  {
    name: 'phone',
    label: 'Phone',
    hidden: false,
    sortable: true,
  },
  {
    name: 'countryId',
    label: 'Country',
    filterModalPlacement: 'right',
    hidden: false,
  },
  {
    name: 'type',
    label: 'Type',
    filterModalPlacement: 'right',
    hidden: false,
    sortable: true,
  },
  {
    name: 'status',
    label: 'Status',
    filterModalPlacement: 'right',
    hidden: false,
    sortable: true,
  },
];

export const newApplicationListColumnsLabels = {
  firstName: 'First Name',
  lastName: 'Last Name',
  companyName: 'Company Name',
  phone: 'Phone',
  email: 'Email',
  type: 'Type',
  status: 'Status',
  countryId: 'Country',
  createdAt: 'Date subm.',
};

export const newApplicationListDefaultSorter = {
  sortProp: newApplicationListColumns[1].name,
  sortDir: SortDir.DESC,
};

export const newApplicationListSchema = {
  firstName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  lastName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  companyName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  phone: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  email: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  countryId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  createdAt: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
    queryNames: ['createdDateFrom', 'createdDateTo'],
  },
  createdDateFrom: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  createdDateTo: {
    value: CustomStringParam,
    type: SchemaFilterType.DATE_RANGE,
  },
  sortProp: {
    value: withDefault(StringParam, newApplicationListDefaultSorter.sortProp),
    type: SchemaFilterType.STRING,
  },
  sortDir: {
    value: withDefault(StringParam, newApplicationListDefaultSorter.sortDir),
    type: SchemaFilterType.STRING,
  },
};

export const newApplicationListFiltersSchema = [
  {
    name: 'firstName',
    type: FilterType.TEXT,
    placeholder: 'Search by name...',
  },
  {
    name: 'lastName',
    type: FilterType.TEXT,
    placeholder: 'Search by name...',
  },
  {
    name: 'companyName',
    type: FilterType.TEXT,
    placeholder: 'Search by company name...',
  },
  {
    name: 'phone',
    type: FilterType.TEXT,
    placeholder: 'Search by phone...',
  },
  {
    name: 'email',
    type: FilterType.TEXT,
    placeholder: 'Search by email...',
  },
  {
    name: 'createdAt',
    type: FilterType.DATE_RANGE,
  },
  {
    name: 'countryId',
    type: FilterType.AUTOCOMPLETE_MULTIPLE,
    placeholder: 'Enter country',
  },
  {
    name: 'type',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'type',
        title: 'Individual',
        value: ApplicationType.INDIVIDUAL,
      },
      {
        name: 'type',
        title: 'Corporate',
        value: ApplicationType.CORPORATE,
      },
      {
        name: 'type',
        title: 'Company officials',
        value: ApplicationType.COMPANY_OFFICIAL,
      },
    ],
  },
  {
    name: 'status',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'status',
        title: 'Incomplete',
        value: NewApplicationStatus.INCOMPLETE,
      },
      {
        name: 'status',
        title: 'Accepted',
        value: NewApplicationStatus.ACCEPTED,
      },
      {
        name: 'status',
        title: 'Waiting for review',
        value: NewApplicationStatus.READY_TO_REVIEW,
      },
      {
        name: 'status',
        title: 'Review in progress',
        value: NewApplicationStatus.REVIEW_IN_PROGRESS,
      },
      {
        name: 'status',
        title: 'Declined',
        value: NewApplicationStatus.DECLINED,
      },
    ],
  },
];
